import React from 'react';
import Reflux from 'reflux';
import { Button } from 'bootstrap';
import { Map } from 'immutable';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import RTE from 'shared/components/rte/rte.jsx';

export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) => row.getIn(['editing', 'type']) === EditableCellTypes.ItemTitle,
      ),
    ),
  ],

  displayName: 'TitleModal',

  render() {
    let { rowState } = this.state;

    if (!rowState) return null;

    return (
      <Modal
        className="csr-modal-item-title-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Segment title"
      >
        <div className="csr-modal-item-title-content">
          {this._getInputNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getInputNode() {
    let {
      rowState: { item },
    } = this.state;

    return (
      <RTE
        ref="rte"
        displayToolbar={false}
        readOnly={false}
        autoFocus
        rteState={item.get('rteTitleState')}
        disableBlur
      />
    );
  },

  _handleDone() {
    const rteState = this.refs.rte.getValue();

    const cellSpec = Map({
      type: EditableCellTypes.ItemTitle,
      value: EditableCellTypes.ItemTitle,
    });

    CuesheetCellActions.saveDataCellChanges(
      this.state.rowState.rowId,
      cellSpec,
      rteState,
    );

    ModalActions.hide(this._getModalId());
  },

  _getModalId() {
    return UIRegions.CuesheetItemTitle;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(UIRegions.CuesheetItemTitle);
    }
  },
});
